import react, { useEffect, useState } from "react";
import ComponentCard from "../../../../components/common/ComponentCard";
import Button from "../../../../components/ui/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "../../../../components/form/Form";
import Label from "../../../../components/form/Label";
import Select from "../../../../components/form/Select";
import Input from "../../../../components/form/input/InputField";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateAreas() {
  const navigate = useNavigate();
  const location = useLocation();
  const area = location.state?.area;

  const [formData, setFormData] = useState({
    name: "",
    status: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    status: "",
  });

  useEffect(() => {
    if (area) {
      setFormData({
        name: area.name || "",
        status: area.status === 1 ? "Current" : "Non-Current",
      });
    }
  } , [area]);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSelectChange = (option: any) => {
    setFormData({
      ...formData,
      status: option,
    });
    setErrors({
      ...errors,
      status: "",
    });
  };
  
  const validate = () => {
    let newErrors: any = {};
    if (!formData.name.trim()) newErrors.name = "Venue Area name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    // Submit updated data to API or data source
    try {
      const token = localStorage.getItem("token");
      const payload = {
        area_id: area.acarea_id,
        name: formData.name,
        status: formData.status,
      };
      
      const response = await fetch(`${apiUrl}/areas`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      console.log(result);
      if (result.success) {
        navigate("/areas");
      }
    } catch (error) {
      console.error("Error updating area:", error);
    }
    
  };

  const handleCancel = () => {
    navigate("/areas");
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this area?")) return;
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/areas/${area.acarea_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token || "",
          },
        }
      );
      if (response.ok) {
        navigate("/areas");
      } else {
        console.error("Failed to delete area");
      }
    } catch (error) {
      console.error("Error deleting area:", error);
    }
  };

  return(
    <>
      <ComponentCard title="Add New Venue Area">
        <Form onSubmit={handleSubmit}>
          <>
            <div className="grid gap-6">
              <div className="col-span-full">
                <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                  Area
                </h4>
              </div>
              {/* Venue Area Name */}
              <div>
                <Label>Area</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
              </div>


              {/* Record Status */}
              <div>
                <Label>Record Status</Label>
                <Select
                  options={[
                    { value: "Current", label: "Current" },
                    { value: "Non-Current", label: "Non-Current" },
                  ]}
                  value={formData.status}
                  onChange={handleSelectChange}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>

              <div className="flex gap-3">
                <Button size="sm" type="submit">
                  Update Changes
                </Button>
                <Button size="sm" variant="outline" onClick={handleCancel} type="button">
                  Cancel
                </Button>
                <button className="px-4 py-3 text-sm font-medium text-white rounded-lg bg-error-800 shadow-theme-xs hover:bg-error-600" onClick={handleDelete}>
							Delete
						</button>
              </div>
            </div>
          </>
        </Form>
      </ComponentCard>
    
    </>
  )
};